import React from 'react'
import { connect } from '@cerebral/react'
import { state } from 'cerebral/tags'
import Group from '../group.js'

export default connect(
  {
    group: state`media.group`
  },
  ({ group }) => <Group item={group} />
)



// WEBPACK FOOTER //
// ./src/components/Media/Strip/activeGroup.js